import { IS_STG } from "../server-select";
import { IS_DEV } from "./env";

export const CDN_BASE_URL = `https://cdn.well-played.gg/${IS_STG || IS_DEV ? "stg" : "prod"}`;
